module.exports = __webpack_public_path__ + "img/listNull.2e7d688d.png";